import { c as _c } from "react/compiler-runtime";
interface MembersDefaultMessageProps {
  defaultMessage: string;
}
export const MembersDefaultMessage: React.FC<MembersDefaultMessageProps> = t0 => {
  const $ = _c(2);
  const {
    defaultMessage
  } = t0;
  let t1;
  if ($[0] !== defaultMessage) {
    t1 = <p className="text-sm text-gray-500">{defaultMessage}</p>;
    $[0] = defaultMessage;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};